import React, { useContext, useEffect, useState, Fragment } from "react";
import { Link, useHistory } from "react-router-dom";
import UserDataContext from "../../context/UserDataContext";
import { Popover } from "@headlessui/react";
import { translate } from "../../translations";

export default function Navbar() {
  const { userData } = useContext(UserDataContext);
  const [isOpenServices, setIsOpenServices] = useState(false);
  const [isOpenOrders, setIsOpenOrders] = useState(false);
  const [isOpenSettings, setIsOpenSettings] = useState(false);
  const [isOpenAbrechnung, setIsOpenAbrechnung] = useState(false);
  let history = useHistory();
  const project = localStorage.getItem("currentProjectID");

  const toggleDropdownServices = () => {
    setIsOpenServices(!isOpenServices);
  };
  const toggleDropdownOrders = () => {
    setIsOpenOrders(!isOpenOrders);
  };
  const toggleDropdownAbrechnung = () => {
    setIsOpenAbrechnung(!isOpenAbrechnung);
  };
  const toggleDropdownSettings = () => {
    setIsOpenSettings(!isOpenSettings);
  };

  if (userData && !localStorage.getItem("currentProjectName")) {
    history.push("/projects");
  }

  useEffect(() => {}, [userData]);

  return (
    <Popover className="relative bg-white">
      <div className="max-w-full mx-auto px-4 ">
        <div className="flex justify-between items-center border-b-2 border-gray-100 py-6 md:justify-start md:space-x-10">
          <div className="flex justify-start lg:w-0 lg:flex-1">
            <a href="/">
              <img className="h-8 w-auto sm:h-10" src="/logo.png" alt="" />
            </a>
          </div>
          {userData && (
            <>
              <a href="/">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                  />
                </svg>
              </a>
              <div className="relative inline-block">
                <button
                  type="button"
                  className="px-4 py-2 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm inline-flex items-center"
                  onClick={toggleDropdownServices}
                >
                  {translate("nav_leistungen")}{" "}
                  <svg
                    class="w-2.5 h-2.5 ml-2.5"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </button>

                {isOpenServices && (
                  <div className="origin-top-right absolute right-0 mt-2 w-44 rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                    <ul
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="options-menu"
                    >
                      <li>
                        <a
                          href="/services"
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        >
                          {translate("nav_überblick")}
                        </a>
                      </li>
                      <li>
                        <a
                          href="/services/new"
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        >
                          {translate("Nav_leistungen_hinzufuegen")}
                        </a>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
              <div className="relative inline-block">
                <button
                  type="button"
                  className="px-4 py-2 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm inline-flex items-center"
                  onClick={toggleDropdownOrders}
                >
                  {translate("Nav_orders")}{" "}
                  <svg
                    class="w-2.5 h-2.5 ml-2.5"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </button>

                {isOpenOrders && (
                  <div className="origin-top-right absolute right-0 mt-2 w-44 rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                    <ul
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="options-menu"
                    >
                      <li>
                        <a
                          href="/orders"
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        >
                          {translate("nav_überblick_order")}
                        </a>
                      </li>
                      {console.log(userData)}
                      {userData &&
                        userData.permissions &&
                        userData.permissions[project] &&
                        userData.permissions[project].arbeitsplan && (
                          <li>
                            <a
                              href="/orders/arbeitsplan"
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            >
                              {translate("Nav_create_arbeitsplan")}
                            </a>
                          </li>
                        )}
                      {userData &&
                        userData.permissions &&
                        userData.permissions[project] &&
                        userData.permissions[project].abnahmeprotokolle && (
                          <li>
                            <a
                              href="/orders/abnahmeprotokoll"
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            >
                              {translate("Nav_create_report")}
                            </a>
                          </li>
                        )}
                      {userData &&
                        userData.permissions &&
                        userData.permissions[project] &&
                        userData.permissions[project].confirmOrder && (
                          <li>
                            <a
                              href="/order-approval"
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            >
                              {translate("Nav_order-approval")}
                            </a>
                          </li>
                        )}
                    </ul>
                  </div>
                )}
              </div>
              {userData &&
                userData.permissions &&
                userData.permissions[project] &&
                userData.permissions[project].abrechnung && (
                  <div className="relative inline-block">
                    <button
                      type="button"
                      className="px-4 py-2 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm inline-flex items-center"
                      onClick={toggleDropdownAbrechnung}
                    >
                      {translate("abrechnung")}
                      <svg
                        class="w-2.5 h-2.5 ml-2.5"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 10 6"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="m1 1 4 4 4-4"
                        />
                      </svg>
                    </button>

                    {isOpenAbrechnung && (
                      <div className="origin-top-right absolute right-0 mt-2 w-44 rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                        <ul
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="options-menu"
                        >
                          <li>
                            <a
                              href="/abrechnung"
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            >
                              {translate("nav_überblick_abrechnung")}
                            </a>
                          </li>
                          {userData &&
                            userData.permissions &&
                            userData.permissions[project] &&
                            userData.permissions[project].invoice && (
                              <li>
                                <a
                                  href="/orders/invoice"
                                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                >
                                  {translate("Nav_create_invoice")}
                                </a>
                              </li>
                            )}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
              {userData &&
                ((userData.permissions[project] &&
                  userData.permissions[project].isProjectAdmin) ||
                  userData.permissions.isAdmin) && (
                  <div className="relative inline-block">
                    <button
                      type="button"
                      className="px-4 py-2 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm inline-flex items-center"
                      onClick={toggleDropdownSettings}
                    >
                      {translate("Nav_einstellungen")}{" "}
                      <svg
                        class="w-2.5 h-2.5 ml-2.5"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 10 6"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="m1 1 4 4 4-4"
                        />
                      </svg>
                    </button>
                    {isOpenSettings && (
                      <div className="origin-top-right absolute right-0 mt-2 w-44 rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                        <ul
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="options-menu"
                        >
                          <li>
                            <a
                              href="/app-settings"
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            >
                              {translate("Nav_projekt-einstellungen")}
                            </a>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                )}
            </>
          )}

          {userData && (
            <>
              <a
                href="/support"
                className="px-4 py-2 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm inline-flex items-center"
              >
                Support
              </a>
              <a href="/profil">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                  />
                </svg>
              </a>
            </>
          )}

          <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
            {!userData && (
              <Link
                to="/login"
                className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 mr-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                  />
                </svg>
                {translate("Nav_login")}
              </Link>
            )}
            {userData && (
              <>
                <Link
                  to="/projects"
                  className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6 mr-2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                    />
                  </svg>{" "}
                  {localStorage.getItem("currentProjectName")
                    ? localStorage.getItem("currentProjectName")
                    : "Projekt auswählen"}
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </Popover>
  );
}
